/*
 * Contains basic SlickGrid formatters.
 *
 * NOTE:  These are merely examples.  You will most likely need to implement something more
 *        robust/extensible/localizable/etc. for your use!
 */
import { numeric } from '../core/numeric';
import { date } from '../core/date';
function escapeHTMLChars(text) {
    if (text == null) {
        return "";
    }
    if (typeof text.replace !== "function") {
        return text;
    }
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
export var EmptyFormatter = function (row, cell, value, columnDef, dataContext) {
    return "";
};
export var ComponentFormatter = EmptyFormatter;
export var YesNoFormatter = function (row, cell, value, columnDef, dataContext) {
    return value ? "Yes" : "No";
};
export var CheckboxFormatter = function (row, cell, value, columnDef, dataContext) {
    return '<div style="text-align:center">' + (value ? "✔" : "-") + '</div>'; // ❌
};
export var CheckmarkFormatter = function (row, cell, value, columnDef, dataContext) {
    return value ? "✔" : "";
};
export var NumericFormatter = function (row, cell, value, columnDef, dataContext) {
    return {
        addClasses: ["right"],
        text: numeric.format(value, columnDef.format)
    };
};
export var DateFormatter = function (row, cell, value, columnDef, dataContext) {
    return date.format(value, columnDef.format);
};
export var HtmlFormatter = function (row, cell, value, columnDef, dataContext) {
    return value || "";
};
export var LookupFormatter = function (row, cell, value, columnDef, dataContext) {
    var _a;
    var vl = columnDef.valueList;
    if (vl) {
        if (Array.isArray(vl)) {
            if (vl.length > 0) {
                if (typeof (vl[0]) === "string") {
                    return escapeHTMLChars(vl.indexOf(value) >= 0 ? value : ""); //TODO: desired?
                }
                else {
                    var vlList = vl;
                    return escapeHTMLChars((_a = vlList.filter(function (x) { return x.value === value; })[0]) === null || _a === void 0 ? void 0 : _a.text);
                }
            }
            else {
                return "";
            }
        }
        else {
            return escapeHTMLChars(vl[value]);
        }
    }
    else {
        console.warn("No values list found for column " + columnDef.id);
    }
    return escapeHTMLChars(value);
};
export var MultiLookupFormatter = function (row, cell, value, columnDef, dataContext) {
    if (value == null || value.length === 0) {
        return "";
    }
    var vl = columnDef.valueList;
    var result = "";
    if (vl == null) {
        console.warn("No values list found for column " + columnDef.id);
        return result;
    }
    if (Array.isArray(vl)) {
        if (vl.length > 0) {
            if (typeof (vl[0]) === "string") {
                result = value.filter(function (v) { return vl.indexOf(v) >= 0; }).join(", ");
            }
            else {
                var vlList = vl;
                result = vlList.filter(function (x) { return value.indexOf(x.value) >= 0; }).map(function (x) { var _a; return (_a = x.text) !== null && _a !== void 0 ? _a : ""; }).join(", ");
            }
        }
    }
    else {
        result = value.map(function (v) { return vl[v]; }).filter(function (v) { return v != null; }).join(", ");
    }
    return result || "";
};
export var TextFormatter = function (row, cell, value, columnDef, dataContext) {
    if (value == null) {
        return "";
    }
    else {
        return escapeHTMLChars(value + "");
    }
};
export var TooltipFormatter = function (row, cell, value, columnDef, dataContext) {
    if (value == null) {
        return "";
    }
    else {
        var result = escapeHTMLChars(value + "");
        return { text: result, toolTip: result };
    }
};
export var MultiLineTextFormatter = function (row, cell, value, columnDef, dataContext) {
    var txt = "";
    if (value != null) {
        txt = escapeHTMLChars(value + "");
    }
    return { text: txt, addClasses: ["slick-wrap"] };
};
function pad(nr) {
    if (nr < 10) {
        return "0" + nr.toString();
    }
    else {
        return nr.toString();
    }
}
export var TimeFormatter = function (row, cell, value, columnDef, dataContext) {
    return value ? (pad(value.getHours()) + ":" + pad(value.getMinutes())) : "";
};
export var DateTimeFormatter = function (row, cell, value, columnDef, dataContext) {
    return DateFormatter(row, cell, value, columnDef, dataContext) + " " +
        TimeFormatter(row, cell, value, columnDef, dataContext);
};
export var ButtonFormatter = function (row, cell, value, columnDef, dataContext) {
    return "<button class='grid-btn'>...</button>";
};
